import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent implements OnInit {
  @Input() classes: string = '';
  @Input() style: string = '';
  @Input() badgeType: string;
  @Input() pillBadge: boolean = false;
  @Input() text: string;
  @Input() title: string;

  badgeClass:  string

  constructor() { }

  ngOnInit(): void {
    this.badgeClass = `badge-${this.badgeType}`;
  }

}
